import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPhone(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#phone_svg__a)">
        <circle cx={88.5} cy={60} r={50} stroke="url(#phone_svg__b)" strokeWidth={20} />
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          d="m83.868 51.706-1.373-6.184A1.94 1.94 0 0 0 80.598 44h-7.21c-1.062 0-1.933.853-1.886 1.914a32.6 32.6 0 0 0 4.341 14.897A32.7 32.7 0 0 0 87.7 72.673c4.563 2.65 9.635 4.049 14.859 4.324 1.071.057 1.942-.819 1.942-1.893v-7.188c0-.912-.632-1.7-1.521-1.898l-6.18-1.374a1.94 1.94 0 0 0-1.796.524l-1.64 1.642c-.591.592-1.499.745-2.226.331a26.16 26.16 0 0 1-9.765-9.77c-.414-.728-.26-1.636.331-2.228l1.641-1.64c.47-.47.668-1.148.524-1.797Z"
        />
      </g>
      <defs>
        <linearGradient
          id="phone_svg__b"
          x1={88.5}
          x2={88.5}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="phone_svg__a">
          <rect width={100} height={100} x={38.5} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPhone);
export default ForwardRef;
